import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue";
import { IBookInfo } from "@/domain/entities/book";
import { BookStatusName } from "@/types";
import useGetLineRouteName from "@/use/useGetLineRouteName";
import LineTypeChip from "../shared/chip/LineTypeChip.vue";


const __default__ = {
  name: "BookHistoryDetailInfo",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  bookInfo: {
    type: Object as PropType<IBookInfo>,
    required: true,
  },
},
  emits: ["onClickBusStopLocation"],
  setup(__props, { expose: __expose }) {
  __expose();





const bookStatusClassTable = {
  [BookStatusName.BOOK]: "active",
  [BookStatusName.NOSHOW]: "no-show",
  [BookStatusName.BOARD]: "board",
  [BookStatusName.CANCEL]: "cancel",
};

const __returned__ = { bookStatusClassTable, get BookStatusName() { return BookStatusName }, get useGetLineRouteName() { return useGetLineRouteName }, LineTypeChip }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})